import React from "react";
import "../../../css/TotalAuth.css";
import mobility from "../../../img/ride.png";

interface TotalAuthProps {
  TotalAuth: string;
}

const TotalAuth = ({ TotalAuth }: TotalAuthProps) => {
  return (
    <div className="auth_amount_container">
      <div className="auth_display">
        <img className="mobility" src={mobility} />
        <div className="auth_amount_title">累計認証完了者数</div>
      </div>
      <div className="auth_amount_of">
        {TotalAuth}
        <span className="unit">人</span>
      </div>
    </div>
  );
};

export default TotalAuth;
